import React, { useState, useEffect } from "react";
import Layout from "../Layout";
import {
  BsArrowDownLeft,
  BsArrowDownRight,
  BsArrowUpRight,
  BsCheckCircleFill,
  BsClockFill,
  BsXCircleFill,
} from "react-icons/bs";
import { DashboardBigChart, DashboardSmallChart } from "../components/Charts";
import {
  appointmentsData,
  dashboardCards,
  memberData,
  transactionData,
} from "../components/Datas";
import { PatientTable } from "../components/Tables";
import { Link, useNavigate } from "react-router-dom";
import Loading from "../Util/Loading";
import staffApi from "../api/staff/staff.api";
import toast from "react-hot-toast";
import userApi from "../api/user/user.api";
import bookingApi from "../api/booking/BookingApi";
import moment from "moment";
import TodayAppointments from "./Dashboad/TodayAppintment";
import TopServices from "./Dashboad/TopServices";
import UpcomingAppointments from "./Dashboad/UpcomingApointment";
import TopTeamMember from "./Dashboad/TopTeamMember";
import MonthlyAppointmentsChart from "./Dashboad/MonthlyApoinmentChart";
import TopServicesChart from "./Dashboad/TopServiceChart";
import CustomersCard from "./Dashboad/CustomerCard";
import CustomerGrowthChart from "./Dashboad/CustomerGrowthChart";

function Dashboard() {
  const [dateRange, setDateRange] = useState([new Date(), new Date()]);
  const [startDate, endDate] = dateRange;
  const [isLoading, setIsLoading] = useState(false);
  const [staffs, setStaffs] = useState([]);
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [data, setData] = useState({});
  const [booking, setBooking] = useState([]);
  const [customers, setCustomers] = useState([]);

  const getAllBookings = async () => {
    try {
      const { response } = await bookingApi.getAllBookings();
      if (response && response.data) {
        setBooking(response.data.booking);
      } else {
        toast.error("No data found");
      }
    } catch (error) {
      toast.error("Something went wrong!");
      console.error("Error fetching bookings:", error);
    }
  };

  const getAllStaff = async () => {
    try {
      const { response, err } = await staffApi.getAllStaffInfo();

      if (response && response.data) {
        setStaffs(response.data.data);
      } else {
        toast.error("No data found");
      }
    } catch (error) {
      toast.error("Something went wrong!");
      console.error("Error fetching data:", error);
    }
  };

  const getAllCustomers = async () => {
    try {
      const { response, err } = await userApi.getAllUsers();

      if (response && response.data) {
        setCustomers(response.data);
      } else {
        toast.error("No data found");
      }
    } catch (error) {
      toast.error("Something went wrong!");
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      await Promise.all([getAllStaff(), getAllBookings(), getAllCustomers()]);
      setIsLoading(false);
    };

    fetchData();
  }, []);

  // console.log({ booking });

  const previewPayment = (_id) => {
    navigate(`/staff/preview/${_id}`);
  };

  if (isLoading) {
    return <Loading />;
  }
  return (
    <Layout>
      <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6">
        {/* 🔹 Row 1 */}
        <div className="bg-drylight dark:bg-neutral-800 p-5 rounded-xl border border-border shadow">
          <MonthlyAppointmentsChart bookings={booking} />
        </div>

        <div className="bg-drylight dark:bg-neutral-800 p-5 rounded-xl border border-border shadow">
          <UpcomingAppointments bookings={booking} />
        </div>

        {/* 🔹 Row 2 */}
        <div className="bg-drylight dark:bg-neutral-800 p-5 rounded-xl border border-border shadow">
          <h2 className="text-yellowdark font-semibold text-text mb-2">
            Today's appointments
          </h2>
          <div className="max-h-[320px] overflow-y-auto pr-1 space-y-4">
            <TodayAppointments bookings={booking} />
          </div>
        </div>

        <div className="bg-drylight dark:bg-neutral-800 p-5 rounded-xl border border-border shadow">
          <h2 className="text-yellowdark font-semibold text-text mb-2">
            Top services
          </h2>
          <TopServicesChart bookings={booking} />
        </div>

        {/* 🔹 Row 3: Side-by-side */}
        <div className="bg-drylight dark:bg-neutral-800 p-5 rounded-xl border border-border shadow w-full">
          <h2 className="text-yellowdark font-semibold text-text mb-2">
            Top team member
          </h2>
          <TopTeamMember bookings={booking} />
        </div>

        <div className="bg-drylight dark:bg-neutral-800 p-5 rounded-xl border border-border shadow w-full">
          <div className="flex justify-between items-center mb-4 flex-wrap gap-2">
            <h2 className="text-yellowdark font-semibold text-text">
              Your staffs
            </h2>
            <p className="text-sm text-text">
              Total :{" "}
              <span className="py-1 px-2 text-yellowlight text-xs rounded-xl">
                {staffs.length}
              </span>
            </p>
          </div>
          <div className="overflow-x-auto">
            <PatientTable
              data={staffs}
              functions={{ preview: previewPayment }}
              used={false}
            />
          </div>
        </div>
        <div className="bg-drylight dark:bg-neutral-800 p-5 rounded-xl border border-border shadow">
          <CustomersCard customers={customers} />
        </div>
        <div className="bg-drylight dark:bg-neutral-800 p-5 rounded-xl border border-border shadow">
          <CustomerGrowthChart customers={customers} />
        </div>
      </div>
    </Layout>
  );
}

export default Dashboard;
